/* global angular */

var ngModule = angular.module('trends');

ngModule.service('ModalManager', ['$modal', '$rootScope', '$document', '$timeout',
    function ($modal, $rootScope, $document, $timeout) {
        var modal = null;
        var previousFocus = null;

        var destroyModal = function () {
            if (modal) {
                modal.destroy();
            }
        };

        this.create = function (opts, initialDataFct) {
            destroyModal();
            if(initialDataFct !== undefined) {
                opts.scope = opts.scope.$new();
                opts.scope.data = {};
                initialDataFct(opts.scope.data).then(function() {
                    modal = $modal(opts);
                });

            }
            else {
                modal = $modal(opts);
            }
        };

        $rootScope.$on('$stateChangeStart', destroyModal);
        $rootScope.$on('modal.show.before', function () {
            previousFocus = $document[0].activeElement;
        });
        $rootScope.$on('modal.hide', function () {
            if (previousFocus) {
                var tmp = previousFocus;
                $timeout( function () {
                    tmp.focus();
                });
                previousFocus = null;
            }
        });
    }
]);
